import React from 'react';
import { CyclingEvent, groupPlannerEvents, plannerAbstand } from '@radevents/shared';
import PlannerAbstand from './PlannerAbstand';

/**
 * Die Agenda von Meine Events: Monate mit ihren Events, dazwischen auf Wunsch der Abstand
 * (`PlannerAbstand`). Beim Monatswechsel steht der Abstand über der Monatsüberschrift, damit
 * die Linie die Lücke überbrückt. Eine Komponente für Seite und Design-Lab.
 */
export default function PlannerAgenda({ events, renderCard, mitAbstand = false }: {
  events: CyclingEvent[]; renderCard: (event: CyclingEvent) => React.ReactNode; mitAbstand?: boolean;
}) {
  let vorher: CyclingEvent | null = null;
  const abstand = (ev: CyclingEvent) => {
    const a = mitAbstand && vorher ? plannerAbstand(vorher, ev) : null;
    vorher = ev;
    return a ? <PlannerAbstand label={a.label} /> : null;
  };
  return <>
    {groupPlannerEvents(events).map(group => {
      const erstes = abstand(group.events[0]);
      return <section className="planner-month" key={group.month} aria-label={group.month}>
        {erstes}
        <h2>{group.month}</h2>
        <div className="planner-month-events">
          {group.events.map((ev, i) => <React.Fragment key={ev.id}>{i > 0 && abstand(ev)}{renderCard(ev)}</React.Fragment>)}
        </div>
      </section>;
    })}
  </>;
}
